module.exports = __webpack_public_path__ + "static/media/ar_grey.aa4c51d3.png";